/**
 * The sim post survey on the participant's phone (POST-SURVEYS). Public: the
 * station code is the key; who is answering comes from the participant link
 * cookie (HttpOnly, set by the server when they enrolled or identified), which
 * the browser sends with these same-origin requests.
 */
import { apiClient } from './client';
import type { IntakeForm, SurveyAnswers, SurveyDefinition } from './intake';

export interface StationRecording {
  id: string;
  procedure_name: string | null;
  started_at: string | null;
  duration_s: number | null;
  answered: boolean;
}

export interface Station {
  organisation: string;
  form: IntakeForm<SurveyDefinition>;
  /** null until this phone is linked to a participant. */
  participant_first_name: string | null;
  recordings: StationRecording[];
}

const base = (code: string) => `/api/v1/post-survey/${encodeURIComponent(code)}`;

export async function openStation(code: string): Promise<Station> {
  const { data } = await apiClient.get<Station>(base(code));
  return data;
}

export async function identifyAtStation(
  code: string,
  who: { email?: string; badge?: string },
): Promise<Station> {
  const { data } = await apiClient.post<Station>(`${base(code)}/identify`, who);
  return data;
}

export async function answerAtStation(
  code: string,
  body: { form_id: string; session_row_id: string | null; answers: SurveyAnswers },
): Promise<void> {
  await apiClient.post(`${base(code)}/responses`, body);
}
